import { Modal, Text } from '@ui/themed';
import { t } from 'i18next';

export function SwitchToQuickSetupModal({
  isOpen,
  closeModal,
  onConfirm,
}: {
  isOpen: boolean;
  closeModal: () => void;
  onConfirm: () => void;
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={closeModal}
      primaryAction={{
        text: t(
          'features:customer_group.components.switch_to_quick_setup_modal.confirm_switch.confirm',
        ),
        onClick: () => {
          onConfirm();
          closeModal();
        },
        danger: true,
      }}
      secondaryAction={{
        text: t('buttons:cancel'),
        onClick: closeModal,
      }}
    >
      <Modal.Header>
        {t('features:customer_group.components.switch_to_quick_setup_modal.confirm_switch.title')}
      </Modal.Header>
      <Modal.Body>
        <Text variant="secondary" size="md">
          {t('features:customer_group.components.switch_to_quick_setup_modal.confirm_switch.body')}
        </Text>
      </Modal.Body>
    </Modal>
  );
}
